/* eslint-disable camelcase */
import { create } from 'apisauce';

import firebase, { firebaseConfig } from '~config/firebase';
import { apiSetup } from '~config/api';

const signInWithEmailAndPassword = ({ email, password, tenantId }) => {
  firebase.auth().tenantId = tenantId;
  return (
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      // This magic improves object that firebase returns
      .then((user) => ({ ok: true, data: JSON.parse(JSON.stringify(user)).user }))
      .catch((error) => ({ ok: false, problem: error }))
  );
};

const refreshToken = (tokenId) => {
  const temporalApi = create({
    baseURL: window.location.origin
  });
  apiSetup(temporalApi);
  return temporalApi.post(`https://securetoken.googleapis.com/v1/token?key=${firebaseConfig.apiKey}`, {
    refreshToken: tokenId,
    grantType: 'refresh_token'
  });
};

export default { signInWithEmailAndPassword, refreshToken };
